import { Div } from '../../../base/components/native/div'
import { H3 } from '../../../base/components/native/h'
import services from '../../../services'
import { CashbackItem } from './cashback-item'

export const ConfirmList = () => {

    const base = Div()
    const title =  H3('لیست تاییدها')
    const list = Div()
    base.append(title, list)
    base.on('mounted', async () => {
        const cashbacks = await services.cashback.getAllByStatus('pending')
        cashbacks.forEach((cashback: any) => {
            list.append(CashbackItem(cashback))
        })

    })
    title.cssClass({
        margin: '0 0 20px 0',
    })
    base.cssClass({
        width: '40%',
        padding: '0 0 20px 20px',
        overflow: 'scroll',
        height: 'calc(100vh - 100px)'
    })

    return base
}